import {
  EducationPriorityLevel,
  IEducationPriority,
} from './education-priority.interface';

const PRIORITY_SEVERITY_RANK: Record<EducationPriorityLevel, number> = {
  CRITICAL: 0,
  MAJOR: 1,
  MINOR: 2,
  TRIVIAL: 3,
};

// Priorities without deadlines follow dated priorities in either sort direction.
function compareEducationPriorityDueDates(
  a: IEducationPriority['dueDate'],
  b: IEducationPriority['dueDate'],
  direction: 'asc' | 'desc' = 'asc',
): number {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.localeCompare(b) * (direction === 'desc' ? -1 : 1);
}

function sortEducationPriorities(items: IEducationPriority[]): IEducationPriority[] {
  return [...items].sort(
    (a, b) =>
      compareEducationPriorityDueDates(a.dueDate, b.dueDate) ||
      PRIORITY_SEVERITY_RANK[a.priority] - PRIORITY_SEVERITY_RANK[b.priority],
  );
}

function getLocalIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function parseLocalIsoDate(isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export {
  compareEducationPriorityDueDates,
  getLocalIsoDate,
  parseLocalIsoDate,
  PRIORITY_SEVERITY_RANK,
  sortEducationPriorities,
};
